import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { insuranceResource } from './request';
export default {
  data() {
    return {
      insuranceInfoList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  created() {
    this.getInsuranceInfoList();
  },
  methods: {
    getInsuranceInfoList() {
      let params = {
        position: 'groupInsurance'
      };
      insuranceResource(params).then(res => {
        this.insuranceInfoList = res.map(item => {
          item.coverUrl = item.coverUrl ? process.env.VUE_APP_File + item.coverUrl : '';
          return item;
        });
        this.pagination.total = res.length;
        console.log(res, 'res');
      });
    },
    onPageChange(page, pagesize) {
      this.pagination.pageSize = pagesize;
      this.pagination.current = page;
    },
    onShowSizeChange(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
    },
    toDetail(item) {
      this.$router.push({
        name: 'groupOrderInsuranceDetail',
        params: {
          id: item.id
        }
      });
      sessionStorage.setItem('insuranceInfo', JSON.stringify(item));
    }
  }
};